/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Admin_Overview_DescriptionInputs */

const es_walkthrough_admin_overview_description = /** @type {(inputs: Walkthrough_Admin_Overview_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde acá podés ver y editar el nombre y logo de tu empresa, consultar el uso de mensajes, embeddings y almacenamiento, y administrar el plan actual.`)
};

const en_walkthrough_admin_overview_description = /** @type {(inputs: Walkthrough_Admin_Overview_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From here you can view and edit your company's name and logo, check message, embedding, and storage usage, and manage the current plan.`)
};

/**
* | output |
* | --- |
* | "From here you can view and edit your company's name and logo, check message, embedding, and storage usage, and manage the current plan." |
*
* @param {Walkthrough_Admin_Overview_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_admin_overview_description = /** @type {((inputs?: Walkthrough_Admin_Overview_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Admin_Overview_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_admin_overview_description(inputs)
	return en_walkthrough_admin_overview_description(inputs)
});
export { walkthrough_admin_overview_description as "walkthrough.admin_overview_description" }